var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({class:_vm.className,domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }